export const anchorWithId: (href: string, anchor?: string) => string = (
  href,
  anchor
) => {
  return anchor?.length ? `${href}#${anchor}` : href
}
